import {useTranslation} from 'next-i18next';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import FilterLabel from '@/src/jobPortal/clinicPositions/components/FilterLabel';
import useClinicPositions, {
  STATUS_JOBS_LIST,
} from '@/src/jobPortal/clinicPositions/hooks/useClinicPositions';
import {RadioButtonCommon} from '@/src/ui';

import css from '../styles/filters.module.css';

interface FilterByStatusProps {
  onChange: Function;
  selectedStatus: string;
}

const FilterByStatus = ({onChange, selectedStatus}: FilterByStatusProps) => {
  const {t} = useTranslation('common');
  const {filterCount} = useClinicPositions();

  const handleChange = (event) => {
    onChange({
      [SEARCH_FILTERS.FILTERS_STATUS]: event.target.id,
      [SEARCH_FILTERS.ORDER_BY]: event.target.getAttribute('data-order'),
    });
  };

  return (
    <div className={css.filterGroup}>
      {STATUS_JOBS_LIST.map((status) => {
        const statusKey = Object.keys(filterCount).find((key) =>
          status.value.includes(key)
        );

        return (
          <div key={status.value} className={css.filterItem}>
            <RadioButtonCommon
              id={status.value}
              type="radio"
              data-order={status.orderBy}
              name="status"
              label={
                <FilterLabel
                  title={t(status.label)}
                  count={filterCount[statusKey]}
                />
              }
              checked={selectedStatus === status.value}
              onChange={handleChange}
              isSemibold={undefined}
              error={undefined}
            />
          </div>
        );
      })}
    </div>
  );
};

export default FilterByStatus;
